import Experience from './Experience/Experience.js'

history.scrollRestoration = 'manual' // currently prevents contact section issue with camera.

const experience = new Experience(
  document.querySelector('canvas.webglRenderer'),
  document.querySelector('.cssRendererWrapper')
)
